module.exports = __webpack_public_path__ + "files/cf1d6087b39cc5cbd7b2d1f925702d68.svg";